import { autoinject, LogManager } from 'aurelia-framework';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { InviteRepository } from "data/repository/invite-repository";
import { EntityManager } from 'aurelia-orm';
import { Invite } from "data/entities/entities";
import { ValidationController } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'core/bootstrap-form-renderer';
import { AppEvents } from 'core/app-events';
import { Prompt } from 'shared/components/prompt/prompt';
import { DialogService } from 'aurelia-dialog';

@autoinject()
export class InviteView {
	alertMessage: string;
	hasMessage: boolean;
	isErrorMessage: boolean;
	logger = LogManager.getLogger('InviteView');

	async getInvites() {
		try {
			this.invites = await this.inviteRepository.findByInviteStatusId(1);
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	inviteRepository: InviteRepository;
	invite: Invite;
	invites: Array<Invite> = [];
	eventSubscriptions: Array<Subscription> = [];

	private unsubscribeFromEvents() {
		for (const entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	onDirectoryChanged(payload) {
		this.initialize();
	}

	subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));	
	}

	async clearForm() {
		this.invite.firstName = "";
		this.invite.lastName = "";
		this.invite.email = "";
		this.invite.confirmEmail = "";
	}

	confirmCancelInvite(id) {
		const invite: Invite = this.invites._findObjectById(id);
		const options = { message: "Are you sure you want to delete this invite?", content: invite.email, title: "Confirm" };
		this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.cancelInvite(id);
			}
		});
	}

	cancelInvite(id) {
		this.inviteRepository.cancelInvite(id);
		this.invites._removeObjectById(id);
	}

	constructor(private entityManager: EntityManager,
		private dialogService: DialogService,
		private validationController: ValidationController,
		private eventAggregator: EventAggregator,
		private bootstrapFormRenderer: BootstrapFormRenderer) {
		this.inviteRepository = this.entityManager.getRepository(Invite);
		this.validationController.addRenderer(bootstrapFormRenderer);
	}

	activate() {
		this.subscribeToEvents();
		this.initialize();
	}

	deactivate() {
		this.unsubscribeFromEvents();
	}

	initialize() {
		this.invite = this.inviteRepository.getNewEntity();
		this.getInvites();
	}

	cancelNewInvite() {
		this.clearAlertMessage();
		this.validationController.reset();
		this.invite = this.inviteRepository.getNewEntity();
	}

	clearAlertMessage() {
		this.hasMessage = false;
		this.alertMessage = null;
		this.isErrorMessage = false;
	}

	setAlertMessage(message: string, isError: boolean) {
		this.isErrorMessage = isError;
		this.alertMessage = message;
		this.hasMessage = true;
	}

	async processInvite() {
		const result = await this.validationController.validate();
		if (result.valid) {
			// validation succeeded
			this.submitInvite();
		} else {
			console.log("failure");
			// validation failed
		}
	}

	async submitInvite() {
		try {
			this.invite.invitedOn = new Date();
			this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
			try {
				await this.invite.save();
				this.setAlertMessage("Successfully sent invite to " + this.invite.email, false);
				this.initialize();
			}
			catch(error)  {
				this.setAlertMessage("There was a problem sending the Invite: " + error, true);
			}
			this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);			
		}
		catch (error) {
			this.setAlertMessage(error, true);
		}
	}
}